module.exports = __webpack_public_path__ + "img/third-image-msg.9cceeab9.png";